var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageNotSupported(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.437 128.437L131.562 123.562L116.5 108.5L87.8121 79.8123L26.4371 18.4373L21.5621 13.5623C19.1246 11.1248 15.1871 11.1248 12.7496 13.5623C10.2496 15.9998 10.2496 19.9373 12.6871 22.3748L22.7496 32.4373V114.75C22.7496 121.625 28.3746 127.25 35.2496 127.25H117.562L127.625 137.312C130.062 139.75 134 139.75 136.437 137.312C138.875 134.875 138.875 130.875 136.437 128.437ZM41.6246 108.5C38.9996 108.5 37.5621 105.5 39.1871 103.437L54.7496 83.4373C55.9996 81.8748 58.3746 81.8123 59.6246 83.3748L72.7496 99.1873L80.0621 89.7498L98.8121 108.5H41.6246ZM135.25 109.562L40.4371 14.7498H122.75C129.625 14.7498 135.25 20.3748 135.25 27.2498V109.562Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNotSupported);
export default __webpack_public_path__ + "static/media/image-not-supported.07125423.svg";
export { ForwardRef as ReactComponent };